import React, {useState, useEffect} from 'react';
import { Container } from 'reactstrap';
import completedImg from '../assets/images/completed.svg';
import inprogressImg from '../assets/images/inprogress.svg';
import cancelledImg from '../assets/images/cancelled.svg';
import pendingImg from '../assets/images/pending.svg';
import checkingdoctorImg from '../assets/images/checkingdoctor.svg';
// import SockJsClient from 'react-stomp';
import userDefault from '../assets/images/user-default.svg';
import phone from '../assets/images/phone.svg';
import { convertUTCtoLocal } from '../helper';
import API from '../helper/API';

const TimeLine = ({currentConsultation, doctorList, setTimeLeft}) => {

  
  const [initiated, setInitiated] = useState('inprogress');
  const [successful, setSuccessful] = useState('pending');
  const [schedule, setSchedule] = useState('pending');
  const [meetDoctor, setMeetDoctor] = useState('pending');
  const [cancelled, setCancelled] = useState(false);
  const [doctorInfo, setDoctorInfo] = useState();
  
  const [meetDoctorDescription, setMeetDoctorDescription] = useState('our team will next arrange a call so that you can begin your consult');

  useEffect(() => {
    onMessageReceived(currentConsultation);
  }, [currentConsultation]);

  useEffect(() => {
    const interval = setInterval(() => {
      API.get(`/user/consultations/dddd?id=${currentConsultation.consultationId}`).then(response => {
        onMessageReceived(response.data);
      })
    }, 10000)
    return () => {
      clearInterval(interval);
    }
  }, []);

  let onMessageReceived = (msg) => {
    if(msg && msg.consultationStatus) {
      switch(msg.consultationStatus) {
        case 'initiated':
          setInitiated('completed');
          setSuccessful('inprogress');
          break;
        case 'payment_successful':
          setInitiated('completed');
          setSuccessful('completed');
          setSchedule('inprogress');
          break;
        case 'payment_failed':
            setInitiated('completed');
            setCancelled(true);
            setTimeLeft(5);
            break;
        case 'cancelled':
            setInitiated('completed');
            setCancelled(true);
            setTimeLeft(5);
            break;
        case 'booked':
          setSchedule('completed');
          setInitiated('completed');
          setSuccessful('completed');
          setMeetDoctor('inprogress');
          if(doctorList) {
            const findDoctor = doctorList.find(doc => doc.doctorId === msg.doctorId);
            if(findDoctor) {
              setDoctorInfo(findDoctor);
            }
          }
          if(msg?.scheduledTime) {
            setMeetDoctorDescription(`consult with assigned physician set for ${convertUTCtoLocal(msg.scheduledTime)}`);
          }else {
            setMeetDoctorDescription('While we arrange a call with your doctor, you can learn more about him');
          }
          break;
        case 'completed':
          setSchedule('completed');
          setInitiated('completed');
          setSuccessful('completed');
          setMeetDoctor('completed');
          setTimeLeft(5);
          break;
        default:
          // code block
      }      
    }
  }

  function findClassNme(steps) {
    if (steps === "completed") {
      return "cub-steps-item-finish";
    } else if (steps === "inprogress") {
      return "cub-steps-item-active cub-steps-item-process";
    } else if (steps === "pending") {
      return "cub-steps-item-pending ";
    }
  }

  const StatusIcon = ({icon}) => {
    let ic = '';
    if(icon === 'completed') ic = completedImg;
    else if(icon === 'inprogress') ic = inprogressImg;
    else if(icon === 'cancelled') ic = cancelledImg;
    else ic = pendingImg;
    return (
      <div className={`cub-steps-item-icon ${icon}`}>
        <img src={ic} alt='' />
      </div>
    );
  }

  const OrderStatus = ({children, status, title, description, tail}) => {
    return(
      <div className={`cub-steps-item  ${findClassNme(status)}`}>
        <div role="button" className="cub-steps-item-container">
          { tail !== 'no' && <div className="cub-steps-item-tail"></div> }
          <StatusIcon icon={status} />
          <div className="cub-steps-item-content">
            <div className="cub-steps-item-title">
              <h3>{title}</h3>
              <p>{description}</p>
              {children && children}
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <Container>
    <div className="cub-steps cub-steps-vertical">
        <OrderStatus status={initiated} title='Payment initiated' description='Payment successfully initiated from your bank' />
        { cancelled ? <OrderStatus status='cancelled' title='Payment Failed' description='The transaction was unsuccessful. Any money that has been debited from your account will be refunded back to you in 7-14 days.' tail="no" /> :
        <OrderStatus status={successful} title='Payment successful' description='The transaction has been successfully completed from your bank' /> }
        { !cancelled && <OrderStatus status={schedule} title='Checking doctor schedule' description='Our team is looking for the next available slot for your instant consult' >
          { schedule !== 'completed' && <img src={checkingdoctorImg} alt='' /> }
        </OrderStatus> }
        { !cancelled && <OrderStatus status={meetDoctor} title='Meet the doctor' description={meetDoctorDescription} tail="no">
          { doctorInfo && <div className='patient-detail-card'>
            <div className="d-flex align-items-start align-items-center mb-3">
              <img className="me-3 rounded-circle" src={doctorInfo.profileImageUrl ? doctorInfo.profileImageUrl : userDefault} width={30} alt='' />
              <h5 className="mt-0 mb-0">{doctorInfo.doctorName}</h5>
            </div>
            <div className="d-flex align-items-start align-items-center mb-3">
              <img className="me-3 rounded-circle" src={phone} width={24} alt='' />
              <p className="mt-0 mb-0">{doctorInfo.consultationTextLabel}</p>
            </div>
            <div className="d-flex align-items-start align-items-center mb-3">
              <img className="me-3 rounded-circle" src={phone} width={24} alt='' />
              <p className="mt-0 mb-0">Over {doctorInfo.yearOfExperience} years of experience</p>
            </div>
            <div className="d-flex align-items-start align-items-center">
              <img className="me-3 rounded-circle" src={phone} width={24} alt='' />
              <p className="mt-0 mb-0">Completed over {doctorInfo.totalNumberOfConsultation} consults</p>
            </div>
          </div> }
        </OrderStatus> }
    </div>
    </Container>
  );
}

export default TimeLine;